<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>国家设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">国家设置</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="showAdd()">
          <span>添加国家设置</span>
        </div>
      </div>
    </div>
    <div class="my-item">
      <div class="custom-wrap">
        <template v-if="list && list.length">
          <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false">
            <template slot-scope="{ row, index }" slot="firstCode">{{row.firstCode}}</template>
            <template slot-scope="{ row, index }" slot="name">{{row.name}}</template>
            <template slot-scope="{ row, index }" slot="nameEn">{{row.nameEn}}</template>
            <template slot-scope="{ row, index }" slot="shortName">{{row.shortName}}</template>
            <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
            <template slot-scope="{ row, index }" slot="action">
              <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
              <span style="display: inline-block;padding: 0 5px;">|</span>
              <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
                <span style="color: #f00;cursor: pointer;">删除</span>
              </Poptip>
            </template>
          </Table>
        </template>
        <div class="u-empty" v-else>暂无数据</div>
      </div>
      <countryAdd
        :show="show"
        @finish="init()"
        @close="show=false;"
        :options="options"
        :modelTitle="modelTitle"
      />
    </div>

  </div>
</template>

<script>
import countryAdd from "../components/country-add.vue";
import { mapActions } from "vuex";

export default {
  // 主办设置
  name: "host-set",
  data() {
    return {
      list: null, 
      edit: false,
      editInfo: false,
      show: false, 
      options:{}, 
      modelTitle:'',
      columns1: [
        {
          title: "首字母",
          key: "firstCode",
          align: "center",
          width: "100"
        },
        {
          title: "中文名称",
          key: "name",
          align: "center"
        },
        {
          title: "英文名称",
          slot: "nameEn",
          key: "nameEn",
          align: "center"
        },
        {
          title: "简称",
          slot: "shortName",
          key: "shortName",
          align: "center"
        },
        {
          title: "排序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  created() {
    this.init();
  },
  components: {
    countryAdd,
  },
  methods: {
    ...mapActions({
      getCountry:'hostSetModule/getCountry',
      delCountry:'hostSetModule/delCountry',
    }),  
    async init() {
      let listData = await this.getCountry();
      if (listData && listData.length > 0) {
        this.list = listData;
      }
    }, 
    async delItem(item) { 
      let result = await this.delCountry(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    showAdd() { // 新增
      this.show = true;
      this.modelTitle = '新增';
      this.options = {
        model:null,
        msg:null,
      }
    },
    editShow(item) { // 编辑
      this.show = true;
      this.modelTitle = '编辑';
      this.options = {
        model:'edit',
        msg:item,
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.common-ad {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
  .custom-wrap {
    margin: 0 auto;
    min-height: 500px;
  } 
}
</style>